import axios from 'axios';

export default {
  getListDivision(params = {}) {
    return axios.get('/v2/report', { params });
  },
  getDetailReport(params = {}) {
    return axios.get('/v2/report/detail', { params });
  },
  getLevel(params = {}) {
    return axios.get('/v2/report/levels', { params });
  },
  getIO(params = {}) {
    return axios.get('/v2/report/detail/io', { params });
  },
  submitIO(data) {
    return axios.post('/v2/submit/io/division', data);
  },
  getFiltered(params = {}) {
    return axios.get('/v2/report/filter', { params });
  },
  getConsolidatedReport(params = {}) {
    return axios.get('/v2/report/consolidate', { params });
  },
  getSummaryConsolidate(params = {}) {
    return axios.get('/v2/report/summary', { params });
  },
  getBackup(params = {}) {
    return axios.get('/v2/backup/spending', { params });
  },
  deleteBackup(id) {
    return axios.delete(`/v2/backup/spending/${id}`);
  }
};
